import type { StylesConfig } from 'react-select';
import type { ClusterOption } from './utils/clusterOptions';

export const RUNTIME_SELECT_WIDTH = 'min(520px, calc(100vw - 32px))';

export const runtimeSelectStyles: StylesConfig<ClusterOption, false> = {
  container: (base) => ({
    ...base,
    width: RUNTIME_SELECT_WIDTH,
    maxWidth: '100%',
  }),
  control: (base, state) => ({
    ...base,
    minHeight: 80,
    borderRadius: 8,
    background: 'var(--color-greyscale-0, #fff)',
    borderColor: state.isFocused
      ? 'var(--color-greyscale-200, #d4d4d8)'
      : 'var(--color-greyscale-100, #e4e4e7)',
    boxShadow: 'none',
    transition: 'border-color 160ms ease, background-color 160ms ease',
    '&:hover': {
      borderColor: 'var(--color-greyscale-200, #d4d4d8)',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '14px 16px',
    overflow: 'hidden',
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    maxWidth: 'calc(100% - 8px)',
    overflow: 'visible',
    whiteSpace: 'normal',
    width: '100%',
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    // The typed text is mirrored by a decorative display inside the open menu
    // (see RuntimeMenuList); this native input stays mounted so react-select
    // keeps focus management working, but must not visually intrude on the
    // rich single-value card.
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    opacity: 0,
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'var(--color-greyscale-500, #71717a)',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 1300,
  }),
  menu: (base) => ({
    ...base,
    marginTop: 4,
    marginBottom: 4,
    borderRadius: 8,
    border: '1px solid var(--color-greyscale-100, #e4e4e7)',
    boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
    width: RUNTIME_SELECT_WIDTH,
    minWidth: RUNTIME_SELECT_WIDTH,
    maxWidth: 'calc(100vw - 32px)',
    overflow: 'hidden',
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    overscrollBehavior: 'contain',
  }),
  option: (base, state) => ({
    ...base,
    padding: '12px 14px',
    backgroundColor:
      state.isSelected || state.isFocused ? 'var(--color-primary-100, #d6eaff)' : 'transparent',
    color: state.isDisabled ? 'var(--color-greyscale-400, #ccc)' : base.color,
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
  }),
};
